import { FieldContext } from "./chunk-57D4P5XD.js";
import { Label_default } from "./chunk-G5ECGGEN.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Field/Field.Label.tsx
import { useContext, useMemo } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "label";
var FIELD_LABEL_CLASSNAME_MAP = {};
var FieldLabel = _a => {
  var _b = _a,
    {
      as,
      className
    } = _b,
    rest = __objRest(_b, ["as", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const {
    id,
    label,
    required,
    requiredLabel
  } = useContext(FieldContext);
  const requiredLabelFallback = "required";
  const requiredLabelValue = requiredLabel || requiredLabelFallback;
  const htmlFor = useMemo(() => Component === "label" ? id : void 0, [Component, id]);
  if (!label) {
    return null;
  }
  return /* @__PURE__ */jsx("div", {
    className: clsx("pd-field__label", className),
    children: required ? /* @__PURE__ */jsx(Label_default, __spreadProps(__spreadValues({
      as: Component,
      htmlFor,
      required: true,
      requiredLabel: requiredLabelValue
    }, rest), {
      children: label
    })) : /* @__PURE__ */jsx(Label_default, __spreadProps(__spreadValues({
      as: Component,
      htmlFor
    }, rest), {
      children: label
    }))
  });
};
var Field_Label_default = FieldLabel;
export { FIELD_LABEL_CLASSNAME_MAP, Field_Label_default };